import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CreditNoteType } from '@app/core';

@Component({
  selector: 'app-credit-note',
  templateUrl: './credit-note.component.html',
  styleUrls: ['./credit-note.component.scss']
})
export class CreditNoteComponent implements OnInit {


  constructor(private route: ActivatedRoute) { }

  creditNote: CreditNoteType;
  service = null;
  creditNoteType = 'USA';
  vatNumber = 'payable';
  totalPages = 1;

  ngOnInit() {
    this.creditNote = this.route.snapshot.data.data;
    console.log(this.creditNote);
    if (this.creditNote.vatNumber !== '' && this.creditNote.vatNumber !== null) {
      this.vatNumber = 'customerVat';
    }

    if (this.creditNote.productDetails !== null && this.creditNote.productDetails.length > 0)  {
      this.totalPages++;
    }

    if (this.creditNote.creditNoteTaxProrates !== null && this.creditNote.creditNoteTaxProrates.length > 0)  {
      this.totalPages++;
    }
  }
}
